import React from 'react';
import { Button, Stack, Tooltip } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

export default function PanelExportActions({ panelId, panelLabel, onExportJson, onExportPdf, disabled }) {
  if (!onExportJson && !onExportPdf) return null;
  return (
    <Stack direction="row" spacing={0.5} sx={{ mb: 1 }}>
      {onExportJson && (
        <Tooltip title="Download panel data as JSON">
          <span>
            <Button
              size="small"
              variant="outlined"
              startIcon={<FileDownloadOutlinedIcon />}
              disabled={disabled}
              onClick={() => onExportJson(panelId)}
            >
              JSON
            </Button>
          </span>
        </Tooltip>
      )}
      {onExportPdf && (
        <Tooltip title="Print / Save as PDF">
          <span>
            <Button
              size="small"
              variant="outlined"
              startIcon={<PictureAsPdfOutlinedIcon />}
              disabled={disabled}
              onClick={() => onExportPdf(panelId, panelLabel)}
            >
              PDF
            </Button>
          </span>
        </Tooltip>
      )}
    </Stack>
  );
}
